import * as React from 'react';

function SvgLongTextIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#21BA30" />
      <path
        d="M15.67 20.575H7.875a.729.729 0 110-1.459h7.795a.73.73 0 110 1.459zM20.125 8.881H7.875a.73.73 0 010-1.458h12.25a.73.73 0 010 1.458zM20.125 12.78H7.875a.73.73 0 110-1.46h12.25a.73.73 0 010 1.46zM20.125 16.676H7.875a.73.73 0 010-1.458h12.25a.73.73 0 010 1.458z"
        fill="#232340"
      />
    </svg>
  );
}

export default SvgLongTextIcon;
